import Image from 'app/Components/Shared/Image/image';
import React, {useState, useEffect, useCallback} from 'react';
import {Swiper, SwiperSlide} from 'swiper/react';
import Config from '../../../Config';
import {prepareUrl} from '../../../utilities/StringHelpers/StringHelpers.js';
import {gtag4} from '../../../utilities/analytics/tracking';

const WorldAndServicesSlider = (props) => {
  useEffect(() => {
    window.addEventListener('scroll', handleNavigation);
    return () => {
      window.removeEventListener('scroll', handleNavigation);
    };
  }, [handleNavigation]);

  const [y, setY] = useState(document.scrollingElement.scrollHeight);
  const [scrollDirection, setScrollDirection] = useState(false);

  var handleNavigation = useCallback(
    (e) => {
      if (window.scrollY > 90) {
        setScrollDirection(true);
      } else {
        setScrollDirection(false);
      }
      setY(window.scrollY);
    },
    [y],
  );

  const onScrollClick = () => {
    window.scrollTo(0, 0);
  };

  const onClick = (item) => {
    gtag4({event: 'HomePageCirclesMenu_Click', section: 'HomePageCirclesMenu', button: item.name});

    var link = item.link?.value;
    prepareUrl(link, props.context);
  };

  return (
    <>
      <nav className={`${props.iContent.navList?.expandedValue.length < 6 ? 'nav less-then-6' : 'nav'}`}>
        <Swiper slidesPerView={4.5}>
          {props.iContent.navList.expandedValue?.map((item, index) => (
            <SwiperSlide onClick={() => onClick(item, index)} key={index}>
              <>
                <div className='item'>
                  <div className='icon'>
                    <Image src={Config.epiBaseUrl + item.iconImage.value?.url} />
                  </div>
                </div>
                <div className='item-text' style={{color: item.textColor?.value}}>
                  {item.text?.value}
                </div>
              </>
            </SwiperSlide>
          ))}
        </Swiper>
      </nav>
      {scrollDirection && (
        <div className='up-arrow' onClick={onScrollClick}>
          <Image className='icon' src={Config.epiBaseUrl + props.iContent.scrollImage.value?.url} />
        </div>
      )}
    </>
  );
};
export default WorldAndServicesSlider;
